import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './lib/auth';
import { ThemeProvider } from './lib/theme-context';
import { ToastProvider } from './components/Toast';
import { AvisoProvider } from './components/Aviso';
import { DialogProvider } from './components/DialogProvider';
import { SocketProvider } from './lib/socket';
import { AvisoPontoFechado } from './components/AvisoPontoFechado';
import { EtiquetasProvider } from './modules/atendimento/lib/etiquetas-context';
import { instalarModalDrag } from './lib/modal-drag';
import { instalarEnterAsTab } from './lib/enter-as-tab';
import { aplicarModoTabletInicial } from './lib/modoTablet';
import { iniciarModoEmergencia } from './lib/emergencia';
// Importar ja registra as respostas offline na camada da API (lib/api.ts).
import { iniciarCopia } from './lib/emergencia-copia';
// Fontes da marca, hospedadas/bundladas (sem depender do Google online).
// Familias registradas: 'Schibsted Grotesk Variable', 'Sora Variable', 'IBM Plex Mono'.
import '@fontsource-variable/schibsted-grotesk';
import '@fontsource-variable/sora';
import '@fontsource/ibm-plex-mono/400.css';
import '@fontsource/ibm-plex-mono/500.css';
import '@fontsource/ibm-plex-mono/600.css';
import './styles.css';

iniciarModoEmergencia();
iniciarCopia();
instalarModalDrag();
instalarEnterAsTab();
aplicarModoTabletInicial();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('root element nao encontrado');

createRoot(rootEl).render(
  <StrictMode>
    <ToastProvider>
      <AvisoProvider>
      <DialogProvider>
        <AuthProvider>
          <ThemeProvider>
            <SocketProvider>
              <EtiquetasProvider>
                <App />
              </EtiquetasProvider>
              {/* Fora do `<App>` e dentro do `<SocketProvider>` de proposito: precisa do
                  `reconectar` do socket, e precisa valer em TODA rota — inclusive as que
                  moram fora do `<Layout>`, como o Telao. Dentro do Layout ele nao
                  alcancaria quem trabalha nessas telas. */}
              <AvisoPontoFechado />
            </SocketProvider>
          </ThemeProvider>
        </AuthProvider>
      </DialogProvider>
      </AvisoProvider>
    </ToastProvider>
  </StrictMode>,
);
